import React, {useContext} from "react";
import PagedSearchTable from "../../components/PagedSearchTable";
import LoggerController from "../../generated/controllers/loggerController";
import {dateTimeOffset} from "../../date";
import AppContext from "../appContext";

const Logger: React.FC = () => {

    const context = useContext(AppContext);

    return <div>
        <PagedSearchTable call={LoggerController.paged} columns={[
            {
                header: 'Date',
                row: (row) => dateTimeOffset(row.date, context.initial.timeOffset, '%d %M %Y %H:%i:%s'),
            },
            {
                header: 'Text',
                row: (row) => row.text
            },
        ]}/>
    </div>
}

export default Logger;